import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { joinPresenceRoom } from "../../actions/presence";
import { startCall } from "../../actions/call.actions";
import { unlockAudio } from "../../utils/audioUnlock";

export default function RoomPresence({ roomId }) {
    const dispatch = useDispatch();
    const me = useSelector(s => s.auth?.user);
    const entry = useSelector(s => s.presence?.rooms?.[roomId]) || { users: [], count: 0 };
    const users = entry.users || [];

    const [pickerOpen, setPickerOpen] = useState(false);

    useEffect(() => {
        if (!roomId || !me?._id) return;
        const unsub = dispatch(
            joinPresenceRoom({
                roomId,
                user: { id: me._id, name: me.fullName || me.name || "Пользователь" },
            })
        );
        return () => unsub && unsub();
    }, [roomId, me?._id, dispatch]);

    const others = useMemo(
        () => users.filter(u => String(u.id) !== String(me?._id)),
        [users, me?._id]
    );

    if (!roomId) return null;

    const callUser = async (userId, video = false) => {
        setPickerOpen(false);
        await unlockAudio();                         // 🔑 разблокируем звук ПРЯМО в клике
        dispatch(startCall({ to: userId, video, chatId: null }));
    };

    return (
        <div className="presencePanel">
            <div className="presencePanel__head" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <span className="presencePanel__title">Онлайн в комнате</span>
                    <span className="presencePanel__badge" style={{ marginLeft: 8 }}>{others.length + 1 /* я + остальные */}</span>
                </div>

                {/* КНОПКА "ПОЗВОНИТЬ" */}
                <div style={{ position: 'relative' }}>
                    <button
                        type="button"
                        onClick={() => setPickerOpen(v => !v)}
                        disabled={!others.length}
                        title={others.length ? "Позвонить пользователю…" : "Некому звонить"}
                    >
                        Позвонить ▾
                    </button>

                    {pickerOpen && (
                        <div
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: '110%',
                                background: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: 10,
                                minWidth: 260,
                                boxShadow: '0 8px 30px rgba(0,0,0,.12)',
                                zIndex: 50,
                                padding: 8
                            }}
                        >
                            {!others.length ? (
                                <div style={{ padding: 8, opacity: .6 }}>Никого кроме вас</div>
                            ) : (
                                others.map(u => (
                                    <div key={u.id} style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                        padding: '6px 8px', borderRadius: 8
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <span style={{
                                                width: 8, height: 8, borderRadius: 9999, background: '#22c55e'
                                            }} />
                                            <div style={{ maxWidth: 160, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {u.name}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: 6 }}>
                                            <button title="Аудиозвонок" onClick={() => callUser(u.id, false)}>📞</button>
                                            <button title="Видеозвонок" onClick={() => callUser(u.id, true)}>🎥</button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="presencePanel__list">
                {users.map(u => (
                    <div key={u.id} className="presenceChip" title={u.name} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span className="presenceChip__dot" />
                        <span className="presenceChip__name">{u.name}</span>
                        {/* Быстрые кнопки звонка напротив каждого (кроме себя) */}
                        {String(u.id) !== String(me?._id) && (
                            <span style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                                <button title={`Позвонить ${u.name}`} onClick={() => callUser(u.id, false)}>📞</button>
                                <button title={`Видео ${u.name}`} onClick={() => callUser(u.id, true)}>🎥</button>
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
